import {Alert} from "antd";
import {useGetCoHostedEvents} from "../../../react-query-hooks/live-events/co-hosts/co-hosts";
import {StyledNoUpcomingCallBox} from "../../calls/upcoming-calls/upcoming-calls.style";
import {FullPageLoader} from "../../full-page-loader";
import {LiveClassCard} from "../upcoming-classes/card";
import {CustomLoadMoreButton} from "../../load-more";

export function CohostedClasses() {
  const getCoHostedEvent = useGetCoHostedEvents("upcoming");
  // console.log({getCoHostedEvent: getCoHostedEvent.data});
  if (getCoHostedEvent.isLoading) {
    return <FullPageLoader />;
  }

  if (getCoHostedEvent.isError) {
    return (
      <Alert
        message="Error"
        description={getCoHostedEvent.error.message}
        type="error"
        showIcon
      />
    );
  }

  const flatMapCohostPages = getCoHostedEvent.data.pages.flatMap(
    (page) => page?.data ?? []
  );
  function fetchNextPage() {
    getCoHostedEvent.fetchNextPage();
  }
  return (
    <div>
      {flatMapCohostPages.length > 0 ? (
        <>
          {getCoHostedEvent.data.pages.map((group) =>
            (group?.data ?? []).map((liveClass) => (
              <LiveClassCard
                key={liveClass.id}
                name={liveClass.name}
                activeSession={liveClass.activeSession}
                attendees={liveClass.attendees}
                callPrice={liveClass.callPrice}
                callPriceCurrency={liveClass.callPriceCurrency}
                cover_image={
                  liveClass.cover_image
                    ? liveClass.cover_image
                    : liveClass.cover_images && liveClass.cover_images.length > 0
                    ? liveClass.cover_images[0].media_url
                    : "/images/no-image-placeholder.png"
                }
                description={liveClass.description}
                eventId={liveClass.id}
                slug={liveClass.slug}
                statusName={liveClass.statusName}
                hostUsername={liveClass.hostProfile.username}
                tiny_url={liveClass.tiny_url}
                session_info={liveClass.session_info}
                is_custom_room={liveClass.is_custom_room}
                roomId={liveClass.roomId}
                video_platform={liveClass.video_platform}
                is_co_host
              />
            ))
          )}
          <CustomLoadMoreButton
            fetchNextPage={fetchNextPage}
            hasNextPage={!!getCoHostedEvent.hasNextPage}
            isFetchingNextPage={getCoHostedEvent.isFetchingNextPage}
          />
        </>
      ) : (
        <StyledNoUpcomingCallBox>
          <p className="info-text">You are not a co-host for any event</p>
        </StyledNoUpcomingCallBox>
      )}
    </div>
  );
}
